import { ASSETS } from '@/constants/assets';

export default function ContactCTASection() {
  return (
    <section id="equipamentos" className="relative min-h-[500px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={ASSETS.equipamentosIndustriais}
          alt="Componentes hidráulicos industriais organizados em armazém da Pilar"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gp-graphite/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 py-20">
        <div className="max-w-3xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
            <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">Componentes Hidráulicos</span>
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
          </div>

          <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-white uppercase tracking-wider mb-6">
            Venda de<br />
            <span className="text-gp-yellow">Equipamentos Industriais</span>
          </h2>

          <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto mb-4 leading-relaxed">
            Bombas, motores, válvulas, comandos, mangueiras e conexões hidráulicas para aplicações industriais, agrícolas e móveis.
          </p>

          <p className="text-gray-400 text-base max-w-2xl mx-auto mb-10 leading-relaxed">
            Fornecimento de componentes hidráulicos com suporte técnico especializado para manutenção, reposição e novos projetos industriais.
          </p>

          <div className="flex items-center justify-center">
            <a
              href="https://wa.me/5527993092922"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 bg-gp-yellow hover:bg-gp-yellow-dark text-gp-graphite px-8 py-4 rounded-full font-semibold text-sm uppercase tracking-wider transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              <div className="w-10 h-10 bg-gp-graphite rounded-full flex items-center justify-center group-hover:bg-white transition-colors duration-300">
                <i className="ri-whatsapp-line text-gp-yellow group-hover:text-gp-graphite w-5 h-5 flex items-center justify-center transition-colors duration-300"></i>
              </div>
              <span>Chamar no WhatsApp</span>
              <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">
            <div className="text-center">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-tools-line text-gp-yellow w-6 h-6 flex items-center justify-center"></i>
              </div>
              <p className="text-white text-sm font-semibold uppercase tracking-wider">Componentes</p>
              <p className="text-gray-400 text-xs mt-1">Linha completa hidráulica</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-map-pin-line text-gp-yellow w-6 h-6 flex items-center justify-center"></i>
              </div>
              <p className="text-white text-sm font-semibold uppercase tracking-wider">Todo Brasil</p>
              <p className="text-gray-400 text-xs mt-1">Atendimento nacional</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-customer-service-line text-gp-yellow w-6 h-6 flex items-center justify-center"></i>
              </div>
              <p className="text-white text-sm font-semibold uppercase tracking-wider">Suporte Técnico</p>
              <p className="text-gray-400 text-xs mt-1">Auxílio na aplicação</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-gp-yellow w-6 h-6 flex items-center justify-center"></i>
              </div>
              <p className="text-white text-sm font-semibold uppercase tracking-wider">Qualidade</p>
              <p className="text-gray-400 text-xs mt-1">Equipamentos confiáveis</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}